(function() {
    function asyncLoad() {
      var urls = ["https:\/\/cdn.addsearch.com\/shopify\/v1\/cms-wrapper.min.js?shop=tarot-puoti.myshopify.com&type=overlay_widget"];
      for (var i = 0; i < urls.length; i++) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = urls[i];
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      }
    };
    if(window.attachEvent) {
      window.attachEvent('onreadystatechange', function() {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
          asyncLoad();
        }
      });
    } else {
        asyncLoad();
      //window.addEventListener('speed_boost_build', asyncLoad, false);
    }
  })();